// SPDX-FileCopyrightText: 2024 Sequent Legal <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export function convertToSnakeCase(obj) {
    var newObj = {};
    Object.keys(obj).forEach(function (key) {
        var snakeKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
        newObj[snakeKey] = obj[key];
    });
    return newObj;
}
export function convertOneToSnakeCase(key) {
    return key.replace(/([A-Z])/g, "_$1").toLowerCase();
}
export function convertToCamelCase(input) {
    return input.replace(/_([a-z])/g, function (match, letter) { return letter.toUpperCase(); });
}
